var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 59 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 59,
    height: 58,
    transform: "translate(3362.627 192.855)",
    fill: "#f0b90b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bnb",
    transform: "translate(-3602 -272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bnb-2",
    "data-name": "bnb",
    transform: "translate(239.373 79.145)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chain-smart-h",
    transform: "translate(3362.962 192.954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M81.839,29.014H71.154V6.54H81.609c4.605,0,7.415,2.3,7.415,5.8v.046a5.171,5.171,0,0,1-2.947,4.836c2.579,1.013,4.191,2.487,4.191,5.527V22.8C90.267,26.988,86.951,29.014,81.839,29.014ZM84.1,13.172c0-1.474-1.151-2.3-3.224-2.3H75.99v4.744h4.559c2.165,0,3.546-.691,3.546-2.395ZM85.339,22.2c0-1.52-1.105-2.441-3.638-2.441H75.99v4.928h5.895c2.165,0,3.5-.783,3.5-2.441V22.2ZM95.7,29.014V6.54h4.928V29.014Zm27.31,0L112.143,14.737V29.014h-4.882V6.54h4.559L122.367,20.4V6.54h4.882V29.014Zm26.435,0-2.072-5.02h-9.487l-2.072,5.02h-5.02L140.42,6.356h4.559l9.625,22.659Zm-6.816-16.672-2.994,7.277h5.987Zm31.363,16.672L163.125,14.737V29.014h-4.882V6.54H162.8L173.349,20.4V6.54h4.882V29.014Zm20.494.414a11.328,11.328,0,0,1-11.514-11.56v-.046A11.42,11.42,0,0,1,194.719,6.217a11.626,11.626,0,0,1,8.842,3.454L200.43,13.31a8.357,8.357,0,0,0-5.757-2.533c-3.776,0-6.54,3.132-6.54,7v.046c0,3.869,2.671,7.046,6.54,7.046,2.579,0,4.145-1.013,5.895-2.625l3.132,3.178A11.5,11.5,0,0,1,194.488,29.429Zm13.218-.414V6.54h16.948v4.421h-12.02V15.52h10.593v4.421H212.634v4.744h12.2v4.421H207.706ZM6.54,22.475,0,29.014l6.54,6.54,6.54-6.54Zm22.475-9.349L40.252,24.363l6.54-6.54L29.014,0,11.237,17.777l6.54,6.54Zm22.475,9.349-6.54,6.54,6.54,6.54,6.54-6.54ZM29.014,44.949,17.777,33.712l-6.54,6.54L29.014,58.029,46.791,40.252l-6.54-6.54Zm0-9.4,6.54-6.54-6.54-6.54-6.54,6.54Z",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M154.609,82.187c0-1.039.928-1.857,2.52-1.857a7.028,7.028,0,0,1,4.2,1.592l1.459-2.056a8.577,8.577,0,0,0-5.615-1.945c-3.073,0-5.283,1.813-5.283,4.51,0,2.874,1.857,3.846,5.151,4.642,2.874.663,3.493,1.26,3.493,2.387,0,1.194-1.061,1.967-2.741,1.967a7.126,7.126,0,0,1-4.885-2.012l-1.636,1.945a9.532,9.532,0,0,0,6.455,2.476c3.25,0,5.527-1.724,5.527-4.642,0-2.586-1.7-3.758-4.974-4.554C155.316,83.933,154.609,83.4,154.609,82.187Z",
    transform: "translate(-81.604 -42.034)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M195.76,82.777v11.1h2.719V78.4h-2.9l-4.709,7.317L186.166,78.4h-2.9V93.874h2.675V82.821l4.841,7.251h.088Z",
    transform: "translate(-98.866 -42.293)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M230.431,78.16h-2.52L221.1,93.745h2.785l1.592-3.736H232.8l1.57,3.736h2.874ZM231.8,87.6h-5.328l2.653-6.19Z",
    transform: "translate(-119.274 -42.164)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M274.074,93.874,269.9,88.016a4.634,4.634,0,0,0,3.692-4.709c0-3.029-2.189-4.908-5.748-4.908h-6.9V93.874h2.719V88.481h3.4l3.8,5.394Zm-3.25-10.412c0,1.592-1.238,2.609-3.183,2.609h-3.979V80.876h3.957C269.631,80.876,270.824,81.76,270.824,83.463Z",
    transform: "translate(-140.767 -42.293)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M299.779,80.92h4.908V78.4H292.13v2.52h4.908V93.874h2.741Z",
    transform: "translate(-157.591 -42.293)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M350.786,91.088l-1.746-1.769a6.066,6.066,0,0,1-4.443,2.012,5.52,5.52,0,0,1,0-11.009,6.154,6.154,0,0,1,4.333,1.923l1.746-2.012a8.066,8.066,0,0,0-6.057-2.41,8,8,0,0,0-.111,16A7.984,7.984,0,0,0,350.786,91.088Z",
    transform: "translate(-181.601 -41.983)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M382.706,87.353v6.521h2.719V78.4h-2.719v6.433h-7.383V78.4H372.6V93.874h2.719V87.353Z",
    transform: "translate(-201.002 -42.293)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M414.561,78.16h-2.52l-6.809,15.585h2.785l1.592-3.736h7.317l1.57,3.736h2.874Zm1.371,9.439H410.6l2.653-6.19Z",
    transform: "translate(-218.604 -42.164)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M445.41,78.4V93.874h2.719V78.4Z",
    transform: "translate(-240.278 -42.293)",
    fill: "#f0b90b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M470.158,89.1l-8.29-10.7h-2.52V93.874h2.675V82.866l8.533,11.009h2.277V78.4h-2.675Z",
    transform: "translate(-247.797 -42.293)",
    fill: "#f0b90b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.c51cffcc5b20802828d8175b05f5c836.svg";
export { ForwardRef as ReactComponent };